/**
 * @typedef {import('./input-types').default} InputProps
 */

import React, { forwardRef } from 'react';

import { Input as InputVersion1 } from './DEPRECATED-version-1';
import { Input as InputVersion2 } from './INTERNAL-version-2';

export const version1 = 'version1';
export const version2 = 'version2';

/**
 * @callback InputChangeHandler
 * @param {React.ChangeEvent<HTMLInputElement>} event
 */

/**
 * @deprecated Use `TextInput` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 * @type {InputProps}
 */
export const Input = forwardRef((props, ref) =>
  (props.version || version1) === version2 ? <InputVersion2 {...props} ref={ref} /> : <InputVersion1 {...props} />,
);
